import React, { useEffect, useState } from 'react'
import cx from 'classnames'

import { AdoptionComponent } from '../../constants/AdoptionComponent'
import { useDsAdoptionAttribute } from '../../utils/dsAdoption'
import Lozenge, { LozengeProps } from '../Lozenge'

import defaultPlaceholder from './avatar-placeholder.png'
import { AvatarRoundProps } from './interfaces'

import cm from './AvatarRound.module.css'

/** An Avatar component displays user profile pictures and status icons/lozenges.
 *
 * [Figma](https://www.figma.com/design/Xf38PdCKeISWnBoh0pLFIIWf/🧱-MC-Desktop-Components?node-id=21127-70617&m=dev) */
export const AvatarRound = ({
  src,
  alt,
  size = 'small',
  variant = 'default',
  lozenge,
  placeholderSrc,
  className,
  id,
  'data-test-id': dataTestId,
}: AvatarRoundProps) => {
  const [isImageValid, setIsImageValid] = useState(false)
  const picturePlaceholder = placeholderSrc ?? defaultPlaceholder
  const adoptionAttribute = useDsAdoptionAttribute(AdoptionComponent.AVATAR_ROUND)

  useEffect(() => {
    if (src) {
      setIsImageValid(true)
    }
  }, [src])

  const content = (
    <>
      {lozenge && variant === 'default' && (
        <Lozenge type={lozenge as LozengeProps['type']} size="medium" className={cm.lozenge} />
      )}
      {variant !== 'default' && <div className={cx(cm.icon, cm[variant])} />}
    </>
  )

  return (
    <div className={cx(cm.avatarContainer, className)} id={id} {...adoptionAttribute}>
      <div className={cx(cm.avatar, size && cm[`size-${size}`])} data-test-id={dataTestId}>
        <img
          src={isImageValid ? src : picturePlaceholder}
          alt={alt ?? 'Avatar'}
          loading="lazy"
          className={cm.avatarImage}
          onError={() => setIsImageValid(false)}
        />
        {size !== 'xsmall' && content}
      </div>
    </div>
  )
}
